"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FiveCircleLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FiveCircleLinear = function FiveCircleLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 30c0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30zm-2 0c0 15.464-12.536 28-28 28S2 45.464 2 30 14.536 2 30 2s28 12.536 28 28z",
    fill: "url(#FiveCircleLinear_svg__FiveCircleLinear_svg__paint0_linear_17373_95550)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.931 29.612l1.053-10.33H35.6v2.433h-8.382l-.626 5.649c1.015-.598 2.168-.897 3.458-.897 1.888 0 3.387.627 4.497 1.879 1.11 1.242 1.665 2.926 1.665 5.051 0 2.135-.579 3.819-1.736 5.052-1.148 1.224-2.756 1.836-4.824 1.836-1.831 0-3.325-.508-4.483-1.523-1.157-1.015-1.816-2.42-1.978-4.212h2.49c.162 1.186.584 2.082 1.267 2.69.683.597 1.584.896 2.704.896 1.224 0 2.182-.418 2.874-1.252.702-.835 1.053-1.988 1.053-3.458 0-1.385-.38-2.495-1.138-3.33-.75-.844-1.75-1.267-3.003-1.267-1.147 0-2.049.252-2.703.755l-.698.569-2.106-.54z",
    fill: "url(#FiveCircleLinear_svg__FiveCircleLinear_svg__paint1_linear_17373_95550)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "FiveCircleLinear_svg__FiveCircleLinear_svg__paint0_linear_17373_95550",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "FiveCircleLinear_svg__FiveCircleLinear_svg__paint1_linear_17373_95550",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  }))));
};

exports.FiveCircleLinear = FiveCircleLinear;
var _default = FiveCircleLinear;
exports.default = _default;